module.exports = __webpack_public_path__ + "img/app_logo.9217e7eb.png";